import MyHeader from '../../components/header';
import MyFooter from '../../components/footer';

import Spacer from '../../components/spacer';
import { auth, db } from '../../firebase';
import { MdOutlineAccessTime } from 'react-icons/md';
import { truncateForLink } from '../../data';
import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './va.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';
import { useApiProviderCtx } from '../../context/api';
const articlesCount = 10;

export const viewaloader =
  (useApiProviderCtx0) =>
  async ({ params, request }) => {
    const { lang, key } = params;
    const { getTop5Articles, getAllSdgPhotos, getArticle } = useApiProviderCtx0;
    let w2 = {};
    try {
      w2 = await getArticle({ lang, key });
    } catch (e) {}
    let b = await getAllSdgPhotos(params);

    return { ...params, article: { ...w2 }, photos: { ...b }, sdgs };
    //return w2;
  };

export default function ViewArticle() {
  const { lang, article, photos } = useLoaderData();
  //const sdg={};
  const navigate = useNavigate();

  const { userbaselink } = useApiProviderCtx();

  //get user state

  useEffect(() => {
    console.log({ article });
  }, [article]);

  const getAuthors = (a) => {
    if (a?.authorIndex == '') {
      return <div>Authored By {a?.['author-name-0']}</div>;
    } else {
      let u = a?.authorIndex?.split(',');
      let t = '';
      u?.forEach((c, i) => {
        t = `${t} ${i + 1}.) ${a?.[`author-name-${c}`]}`;
      });
      return <div>Authored By {t}</div>;
    }
  };

  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          {/*<Spacer />
          
		<h1>View Article</h1>*/}

          <div className={l.vaCon}>
            {/*<div className={l.le}>
               

              {article?.sections?.map((v, i) => {
                return <div key={i}>{JSON.stringify(v)}</div>;
              })}
              {article?.sections ? null : <p>No sections</p>}
            </div>*/}

            <div className={l.mi}>
              {/*
    <h1>Content</h1>*/}
              <h1>{article?.article_title}</h1>
              {getAuthors(article)}

              <p className={l.pub}>
                {' '}
                <MdOutlineAccessTime /> published on {new Date(article?.yop).toDateString()}
              </p>
              <p>posted {new Date(article?.postedOn).toDateString()}</p>

              <p className={l.bo}>{article?.article_abstract}</p>

              <p className={l.bo}>{article?.article_abstract}</p>
              {/*JSON.stringify(article)*/}

              {/*use link for user*/}
              <a href={`${userbaselink}/read/${article?.key}/${truncateForLink(slug(article?.article_title))}`}>
                Read Full publication
              </a>
            </div>

            <div className={l.ri}>
              <h1>SDGs</h1>
              <div className={l.sdglist}>
                {sdgs?.map((s, i) => {
                  return (
                    <div key={i}>
                      <a href={`/en/${slug(s?.name)}`}>{s?.name}</a>
                      <br />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <MyFooter />
        </div>
      </div>
    </>
  );
}
